import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ServiceStock } from '../../service-stock.service';
import { MobileService } from 'src/app/mobile.services';
import { DebitCardDetail } from 'src/app/models/Debit-card-details.model';
declare var entrust: any;

declare var $: any;
@Component({
  selector: 'app-tapnpay-nfc-inst-form',
  templateUrl: './tapnpay-nfc-inst-form.component.html',
  styleUrls: ['./tapnpay-nfc-inst-form.component.scss']
})
export class TapnpayNfcInstFormComponent implements OnInit {
  @Input() containerData: DebitCardDetail;
  displayTooltip: boolean;
  maskedcardNumber: any;
  cardReferenceNumber: any;
  cardNumber: any;
  CardDetails: any;
  CardType: any;
  digitalCardNum: any;
  tspId: any;
  constructor(private router: Router,
    private services: ServiceStock,
    private mobileService: MobileService,
    private location: Location) {
    this.CardDetails = location.getState();
    this.cardNumber=this.CardDetails.cardData.CardNumber;  
   // this.cardNumber = "mc4211";
    this.CardType = this.CardDetails.cardData.CardType;
    this.maskedcardNumber = (this.cardNumber).substr(-4);
     this.cardReferenceNumber=this.CardDetails.cardData.CardRefNO; 
     this.digitalCardNum = this.CardDetails.cardData.digitalCardNum;

   //this.cardReferenceNumber = "mc4211";
  }


  ngOnInit(): void {
    $('.main-header').hide();
    $('.footer-dock-menu').hide();
    //this.nfcPay(this.containerData.cardRefNumber);
    this.timerfunc(this, 'nfc');
   // this.getTokenDetails(this.cardReferenceNumber);
  // document.getElementById("tspid").innerHTML =localStorage.getItem("tsp");

  }

  onClose() {
    //  $('.main-header').show();
    //  $('.footer-dock-menu').show();
    this.router.navigate(['/home', 'cards']);

  }
  enableTooltip() {
    if (this.displayTooltip == true) {
      this.displayTooltip = false;
    }
    else {
      this.displayTooltip = true;
    }
  }


  timerfunc(that, path) {
    if (path == "nfc") {
      var timeleft = 60;
      document.getElementById("countdown").innerHTML = timeleft.toString();
      that.mobileService.downloadTimer = setInterval(function () {
        timeleft -= 1;
        document.getElementById("countdown").innerHTML = timeleft.toString();
        if (timeleft <=0) {
          clearInterval(that.mobileService.downloadTimer);
          document.getElementById("countdown").innerHTML = "";
          $('.main-header').show();
          $('.footer-dock-menu').show();
          if (that.mobileService.tapPay != "paid") {
            that.cancelTransaction();
            that.router.navigate(['/home', 'cards']);
          }
        }
      }, 1000);
    }
  }

  // getTokenDetails(cardRefNo){
  //   var that = this;
  //   entrust.getTokenDetails(cardRefNo,sCallback,fCallback);
  //   function sCallback(response){
  //     // document.getElementById("tspid").innerHTML = response.tspId;
  // }
  // function fCallback(arg){
  //   console.log(arg);
  // }
  // }

  cancelTransaction(){
    entrust.cancelTransaction("",sCallback,fCallback);
    function sCallback(arg){
            console.log(arg);
            }
            function fCallback(arg){
            console.log(arg);
            // alert(arg);
    }
    }

    nfcClose(){
      clearInterval(this.mobileService.downloadTimer);
      this.cancelTransaction();
      this.router.navigate(['/home', 'cards']);
      $('.main-header').show();
      $('.footer-dock-menu').show();
    }

}
